// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"4897d375","227":"a63b4f73","453":"ce849474","582":"f225e6a3","612":"0aad683d","620":"9a278e34","918":"9fff52cb","976":"5c9763b6"}[chunkId] + ".chunk.js";
};